export const servicesData = [
  {
    id: 1,
    icon: "🏢",
    title: "Property Management",
    description: "Representation of owners and syndicates, annual budget preparation, financial oversight, vendor management.",
    features: [
      "Centralized coordination",
      "Transparent reporting",
      "Dispute resolution",
      "Legal documentation"
    ],
    color: "#1a365d"
  },
  {
    id: 2,
    icon: "🔧",
    title: "Facilities Management",
    description: "Supervision model with qualified service providers, quality assurance, preventive maintenance.",
    features: [
      "Safety & compliance",
      "Cost control",
      "No conflicts of interest",
      "Technical solutions"
    ],
    color: "#d4af37"
  },
  {
    id: 3,
    icon: "🤝",
    title: "Institutional Partnerships",
    description: "Proven track record managing portfolios for major banks and institutions across GCC.",
    features: [
      "Bank portfolio management",
      "Luxury developments",
      "Award-winning service",
      "Regional expertise"
    ],
    color: "#0a2540"
  }
];

export const benefitsData = [
  {
    id: 1,
    icon: "🌍",
    title: "Regional Expertise",
    description: "30+ years experience across Qatar, UAE, and Saudi Arabia"
  },
  {
    id: 2,
    icon: "⚖️",
    title: "Neutral & Transparent",
    description: "Single responsible party reducing disputes and ensuring accountability"
  },
  {
    id: 3,
    icon: "💰",
    title: "Cost-Focused",
    description: "Disciplined cost control to protect owners' assets"
  },
  {
    id: 4,
    icon: "🛡️",
    title: "Professional Governance",
    description: "Institutional processes tailored for Lebanese market"
  },
  {
    id: 5,
    icon: "🏆",
    title: "Award-Winning",
    description: "Recipient of prestigious Arabian Property Awards"
  },
  {
    id: 6,
    icon: "👥",
    title: "Who We Serve",
    description: "Residential, commercial, mixed-use, and institutional owners"
  }
];

export const timelineData = [
  {
    year: "1986",
    title: "Founded in Dubai",
    description: "Started as a visionary real estate agency"
  },
  {
    year: "2009",
    title: "Qatar Launch",
    description: "Expanded to Qatar with premium services"
  },
  {
    year: "2023",
    title: "Arabian Property Awards",
    description: "Received prestigious award for excellence"
  },
  {
    year: "2026",
    title: "Lebanon Launch",
    description: "Coming soon to Lebanon",
    highlight: true
  }
];

export const partnersData = [
  { id: 1, name: "CBQ", type: "Bank", description: "Qatar's largest bank" },
  { id: 2, name: "QIB", type: "Bank", description: "Qatar's largest Islamic bank" },
  { id: 3, name: "The Pearl", type: "Development", description: "Premier waterfront development" },
  { id: 4, name: "Viva Bahriya", type: "Towers", description: "Luxury residential towers" }
];